module.exports = __webpack_public_path__ + "img/Search.94fbea9a.svg";